// removed by extract-text-webpack-plugin
module.exports = {"FiltersToggle":"_1OSOb1O3AFAN3rrrIg3IbH","MainColumn":"_2lNkgOTS7YJd7fgPmjfIwI","SidebarColumn":"_3vSirUbTX8UTgNAhokZwDk"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ComponentsOfAdministrator/AdminFiltersToggle/styles.module.css
// module id = 44
// module chunks = 0